import {
	focusPortRange,
	openPortRangeSection,
} from './adapter';
import {
	openPortRangeCreateModal,
	openPortRangeDeleteModal,
} from './modal';
import {resolvePortRange} from './resolver';

/**
 * Port Range.
 *
 * Delete is the only row action this table has - its edit is
 * commented out. It also passes search={true} with no handler,
 * so no search is offered either.
 *
 * Declares no fields: the agent finds one and opens the form rather than
 * filling it in.
 */
const portRangePlugin = {
	id: 'port_range',
	version: 1,
	commandVersion: 1,
	resource: 'port_range',
	operations: ['options', 'list', 'edit', 'create', 'delete'],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['profile.dashboard'],
	},
	sections: {
		'profile.port_ranges': openPortRangeSection,
	},
	resolvers: {
		port_range: resolvePortRange,
	},
	focusHandlers: {
		port_range: (command) =>
			focusPortRange(command.params?.entity_id),
	},
	modals: {
		'port_range.create': openPortRangeCreateModal,
		'port_range.delete': openPortRangeDeleteModal,
	},
};

export default portRangePlugin;
